module.exports = __webpack_public_path__ + "img/block-lesson.dad6716b.svg";